export default "<script src=\"/front_pc/src/js/vendor.js\"></script>\r\n<script src=\"/front_pc/src/js/main.js\"></script>"